/**
 * `Node` interface's `type` property.
 */
export var NodeType = /*#__PURE__*/function (NodeType) {
  NodeType[NodeType["Text"] = 0] = "Text";
  NodeType[NodeType["ChannelLink"] = 1] = "ChannelLink";
  NodeType[NodeType["UserLink"] = 2] = "UserLink";
  NodeType[NodeType["URL"] = 3] = "URL";
  NodeType[NodeType["Command"] = 4] = "Command";
  NodeType[NodeType["Emoji"] = 5] = "Emoji";
  NodeType[NodeType["PreText"] = 6] = "PreText";
  NodeType[NodeType["Code"] = 7] = "Code";
  NodeType[NodeType["Italic"] = 8] = "Italic";
  NodeType[NodeType["Bold"] = 9] = "Bold";
  NodeType[NodeType["Strike"] = 10] = "Strike";
  NodeType[NodeType["Quote"] = 11] = "Quote";
  NodeType[NodeType["Root"] = 12] = "Root";
  return NodeType;
}(NodeType || {});